import { render, staticRenderFns } from "./WordImageGenerator.vue?vue&type=template&id=1a4f64bb"
import script from "./WordImageGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./WordImageGenerator.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports